module.exports = __webpack_public_path__ + "static/media/star-empty.ac032685.svg";